import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import { GenericLinkModule, IconThemeReverseModule } from '../../../../shared';
import { CatalogBreadcrumbComponent } from './catalog-breadcrumb.component';

@NgModule({
  imports: [CommonModule, NzIconModule, UrlModule, GenericLinkModule, I18nModule, IconThemeReverseModule],
  declarations: [CatalogBreadcrumbComponent],
  exports: [CatalogBreadcrumbComponent],
})
export class CatalogBreadcrumbModule {}
